import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as microsoftTeams from "@microsoft/teams-js";
import User from '_class/User';
import { setPageActions, setPageTitle } from 'actions/header';
import { getEducationGroups, getSectionByGraphId } from 'actions/sections';
import SectionForm from 'containers/Forms/SectionForm';
import Modal from 'containers/Modals/Modal';
import MyPlans from 'containers/Overview/Sections/MyPlans';
import SchoolSettingsForm from 'teams/containers/Forms/SchoolSettings';
import Assessments from 'teams/containers/Sections/Assessments';
import AssignmentsSection from 'teams/containers/Sections/Assignments';
import { Button, translate } from '@haldor/ui';
import { Spinner } from 'UI';

var HaldorTab = /*#__PURE__*/function (_Component) {
  _inherits(HaldorTab, _Component);

  var _super = _createSuper(HaldorTab);

  function HaldorTab(props) {
    var _this;

    _classCallCheck(this, HaldorTab);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.user);
      console.log("Haldor Tab loading");

      _this.props.setPageTitle(_this.props.translate('overview'));

      if (!user.isStudent()) {
        var actions = [{
          type: 'icon',
          onClick: _this.toggleGroupSettings,
          icon: 'cog_bw'
        }];

        _this.props.setPageActions(actions);
      }

      try {
        if (window != null && window.zEACLoaded != null && window.zEACLoaded) {
          window.zESettings = {
            webWidget: {
              helpCenter: {
                filter: {
                  category: '360002911500-Haldor-Planering'
                }
              },
              color: {
                theme: '#0645ad',
                launcher: '#0645ad'
              },
              offset: {
                horizontal: '0px',
                vertical: '0px'
              },
              launcher: {
                label: {
                  '*': ''
                }
              },
              zIndex: 99999999999
            }
          };
          window.zE('webWidget', 'show');
        }

        microsoftTeams.app.getContext().then(function (context) {
          var group = _this.props.group;
          console.log(context);

          if (group != null) {
            _this.setState({
              groupId: group.id,
              noSectionFound: false,
              teamsContext: context
            });
          } else {
            _this.setState({
              noSectionFound: true,
              teamsContext: context
            });
          }
        });

        if (_this.props.services != null) {
          _this.services = {
            microsoft: _this.props.services.microsoft,
            haldor: _this.props.services.haldor
          };

          _this.setState({});
        }
      } catch (e) {
        console.error(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "consentedToTenantService", function (serviceId) {
      return _this.props.tenantServices != null && _this.props.tenantServices.find(function (service) {
        return service.serviceId == serviceId && moment(service.serviceEnd).isSameOrAfter(moment(), 'day') && service.consented !== null;
      }) != null;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroupSettings", function (shouldReload) {
      _this.setState({
        groupForm: !_this.state.groupForm
      });

      if (shouldReload == true) {
        microsoftTeams.app.getContext().then(function (context) {
          _this.props.getSectionByGraphId(context.team.groupId);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSchoolSettingChange", function (id) {
      return new Promise(function (resolve) {
        microsoftTeams.app.getContext().then(function (context) {
          Promise.all([_this.props.getSectionByGraphId(context.team.groupId), _this.props.getEducationGroups()]).then(function () {
            _this.setState({
              groupId: id,
              noSectionFound: false
            });

            resolve(1);
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderEducationGroup", function () {
      var hasAssignments = _this.services.microsoft;
      var user = new User(_this.props.user);
      var school = user.getActiveSchool();

      var consentedPlanningService = _this.consentedToTenantService('HALDOR_COURSEPLANNING');

      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, _this.props.group != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.groupForm,
        onClose: _this.toggleGroupSettings,
        title: _this.props.group.title
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: _this.toggleGroupSettings,
        editView: true,
        section: _this.props.group
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "section",
        id: "section-plans"
      }, _this.props.groups.length > 0 ? /*#__PURE__*/React.createElement(MyPlans, {
        groupid: _this.state.groupId,
        dateRestriction: false,
        overview: true
      }) : null), hasAssignments && school.type != 'PRESCHOOL' && (_this.state.teamsContext.team.userRole === 0 || _this.state.teamsContext.team.userRole === 1 && consentedPlanningService) ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        id: "section-assignments"
      }, /*#__PURE__*/React.createElement(AssignmentsSection, {
        limit: 9,
        groupid: _this.state.groupId,
        overview: true
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "section",
        id: "section-assessments"
      }, /*#__PURE__*/React.createElement(Assessments, {
        groupId: _this.state.groupId
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderMentorGroup", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, _this.props.group != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.groupForm,
        onClose: _this.toggleGroupSettings,
        title: _this.props.group.title
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: _this.toggleGroupSettings,
        editView: true,
        section: _this.props.group
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center',
          marginTop: '4rem'
        }
      }, _this.props.translate('haldor-tab-mentor-group-not-supported')));
    });

    _this.state = {
      groupId: null,
      noSectionFound: false,
      groupForm: false,
      teamsContext: null
    };
    _this.services = {
      microsoft: props.services.microsoft,
      haldor: props.services.haldor
    };
    return _this;
  }

  _createClass(HaldorTab, [{
    key: "render",
    value: function render() {
      var user = new User(this.props.user);

      if (this.state.noSectionFound) {
        if (user.isStudent()) {
          return /*#__PURE__*/React.createElement("div", {
            className: "overview"
          }, /*#__PURE__*/React.createElement("div", {
            className: "container"
          }, /*#__PURE__*/React.createElement("h2", null, this.props.translate('no-teams-connection')), /*#__PURE__*/React.createElement("p", {
            style: {
              marginTop: '1rem'
            }
          }, this.props.translate('no-teams-connect-student-text'))));
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "overview"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-container create-course-page course-form"
        }, /*#__PURE__*/React.createElement("h2", null, this.props.translate('no-teams-connection')), /*#__PURE__*/React.createElement("p", {
          style: {
            marginTop: '1rem',
            marginBottom: '2rem'
          }
        }, this.props.translate('no-teams-connection-teacher-text')), /*#__PURE__*/React.createElement(SchoolSettingsForm, {
          onSubmit: this.onSchoolSettingChange,
          onboarding: true
        }), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        })));
      }

      if (this.state.groupId == null) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      if (this.props.group.type == 'EDUCATION_GROUP') {
        return this.renderEducationGroup();
      }

      return this.renderMentorGroup();
    }
  }]);

  return HaldorTab;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    tenantServices: state.Services.tenantServices,
    groups: state.sections.educationGroups,
    services: state.Services.availableServices,
    user: state.user.currentUser,
    group: state.sections.graphSection,
    isAppConsented: state.Services.isAppConsented
  };
}

export default connect(mapStateToProps, {
  getEducationGroups: getEducationGroups,
  setPageActions: setPageActions,
  setPageTitle: setPageTitle,
  getSectionByGraphId: getSectionByGraphId
})(HaldorTab);